/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrescriptionMedicationDosing
 */
export interface PrescriptionMedicationDosing {
    /**
     * 
     * @type {string}
     * @memberof PrescriptionMedicationDosing
     */
    dosage?: string;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionMedicationDosing
     */
    dosage_unit?: string;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionMedicationDosing
     */
    frequency?: string;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionMedicationDosing
     */
    time?: string;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionMedicationDosing
     */
    time_unit?: string;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionMedicationDosing
     */
    connector?: PrescriptionMedicationDosingConnectorEnum;
}


/**
 * @export
 */
export const PrescriptionMedicationDosingConnectorEnum = {
    And: 'AND',
    Then: 'THEN'
} as const;
export type PrescriptionMedicationDosingConnectorEnum = typeof PrescriptionMedicationDosingConnectorEnum[keyof typeof PrescriptionMedicationDosingConnectorEnum];


/**
 * Check if a given object implements the PrescriptionMedicationDosing interface.
 */
export function instanceOfPrescriptionMedicationDosing(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PrescriptionMedicationDosingFromJSON(json: any): PrescriptionMedicationDosing {
    return PrescriptionMedicationDosingFromJSONTyped(json, false);
}

export function PrescriptionMedicationDosingFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrescriptionMedicationDosing {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dosage': !exists(json, 'dosage') ? undefined : json['dosage'],
        'dosage_unit': !exists(json, 'dosage_unit') ? undefined : json['dosage_unit'],
        'frequency': !exists(json, 'frequency') ? undefined : json['frequency'],
        'time': !exists(json, 'time') ? undefined : json['time'],
        'time_unit': !exists(json, 'time_unit') ? undefined : json['time_unit'],
        'connector': !exists(json, 'connector') ? undefined : json['connector'],
    };
}

export function PrescriptionMedicationDosingToJSON(value?: PrescriptionMedicationDosing | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'dosage': value.dosage,
        'dosage_unit': value.dosage_unit,
        'frequency': value.frequency,
        'time': value.time,
        'time_unit': value.time_unit,
        'connector': value.connector,
    };
}

